<template>
  <div class="file-container">
    <div class="file-title">
      <div class="whitespace-no-wrap mr-2">PERSONNEL FILE</div>
      <div class="flex-1 border-b border-blue-lighter" />
    </div>
    <div class="mt-8 flex flex-col sm:flex-row">
      <div class="file-photo">
        <img :src="profileImage">
      </div>
      <div class="file-text__container">
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Full Name:</span>
          <span>{{ file.fullName.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.fullName.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">User ID:</span>
          <span>{{ file.userId.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.userId.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Rm:</span>
          <span>{{ file.rm.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.rm.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Age:</span>
          <span>{{ file.age.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.age.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Arrival Day:</span>
          <span>{{ file.arrival.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.arrival.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Current Occupation:</span>
          <span>{{ file.currentOccupation.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.currentOccupation.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Previous Occupation:</span>
          <span>{{ file.previousOccupation.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.previousOccupation.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Previous Work Location:</span>
          <span>{{ file.previousWorkLocation.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.previousWorkLocation.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Marital Status:</span>
          <span>{{ file.maritalStatus.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.maritalStatus.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Spouse's Name:</span>
          <span>{{ file.spouse.value }}</span>
          <span class="italic text-blue-light font-bold ml-2">{{ file.spouse.extraInfo }}</span>
        </div>
        <div class="mb-2">
          <span class="text-blue-lighter mr-2">Children:</span>
          <span>{{ file.children.length ? 'Yes' : 'No' }}</span>
        </div>
        <div
          v-for="child in file.children"
          :key="child.name"
        >
          <div class="mb-2">
            <span class="text-blue-lighter mr-2">Name:</span>
            <span>{{ child.name }}</span>
            <span class="italic text-blue-light font-bold ml-2">{{ child.extraInfo }}</span>
          </div>
          <div class="mb-2">
            <span class="text-blue-lighter mr-2">Status:</span>
            <span>{{ child.status }}</span>
          </div>
        </div>
        <div
          v-if="file.medicalRecords.length"
          class="mb-2"
        >
          <span class="text-blue-lighter mr-2">Medical Records:</span>
        </div>
        <div
          v-for="(record, index) in file.medicalRecords"
          :key="`records-${index}`"
          class="mb-2"
        >
          <span :class="{'italic text-blue-light font-bold': record.highlight }">{{ record.text }}</span>
        </div>
        <div
          v-if="file.previousDisciplinaryActions.length"
          class="mb-2"
        >
          <span class="text-blue-lighter mr-2">Previous Disciplinary Actions:</span>
        </div>
        <div
          v-for="(action, index) in file.previousDisciplinaryActions"
          :key="`action-${index}`"
          class="mb-2"
        >
          <span :class="{'italic text-blue-light font-bold': action.highlight }">{{ action.text }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentsFile',

  props: {
    file: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    profileImage() {
      return `${process.env.BASE_URL}img/${this.file.image}`
    },
  },
}
</script>

<style lang="postcss" scoped>
.file {
  &-container {
    font-family: 'input-mono';
    @apply p-8;
  }

  &-title {
    font-size: 16px;
    @apply text-blue-lighter uppercase flex;
  }

  &-photo {
    min-width: 200px;

    & img {
      width: 175px;
      height: 263px;
      @apply border border-blue p-2 m-2;
    }
  }

  &-text {
    &__container {
      font-size: 12px;
      @apply text-blue;
    }
  }
}
</style>
